import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import signalRHelper from "../../../utils/signalRHelper";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import TrackSummary from "./trackSummary";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TrackLog from "./trackLog";
import RealTimeTemperature from "./realTImeTemperature";
import RealTimeSpeed from "./realTimeSpeed";
import { utcToDate } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import AnimateTable from "../../commoncomponents/animateTable";
import moment from "moment";
import { setLoadingPage, setReportAssetId, setReportCalendatDate, setReportAssetName } from "../../../reducers/actions";
import { connect } from "react-redux";
import GridLoader from "react-spinners/GridLoader";
import queryString from "query-string";

import RealMap from "../../maps/realMap";

class Track extends Component {

  constructor(props) {
    super(props);
    this.state = {
      trackSelection: true,
      assetNameTable: "",
      realTimeData: [],
      trackDataTotal: [],
      sensorAGraph: [],
      sensorBGraph: [],
      speedGraph: [],
      showContent: false,
      errorLoader: false,
      assetName: "",
      assetId: "",
      reportDetails: "",
      assetSelect: false,
      reportLoader: false,
      dateSelect: true,
      selectedDate: moment().format("YYYY-MM-DD"),
      utcObj: {},
      speedObj: {},
      mapChange: "",
      singleTruckZoom: "",
    };
  }

  async componentDidMount() {
    this.handleSignalR();
    const values = queryString.parse(this.props.location.search);
    if (values.assetId) {
      await this.setState({
        assetName: values.assetName,
        assetId: values.assetId,
      });
      this.handleCreateReport();
    }
  }

  handleAssetName = (assetName) => {
    this.setState({ assetName });
  };

  handleCreateReport = () => {
    this.props.setReportAssetIdAction(this.state.assetId);
    this.props.setReportAssetNameAction(this.state.assetName);
    this.props.setReportCalendatDateAction(moment().format("YYYY-MM-DD"));

    let url = `${apiHost}/api/Assets/LatesteventByAssetid/${this.state.assetId}`;
    this.setState({ showContent: true, reportLoader: true });
    this.setTruck(url);

    signalRHelper.setAssetFilter(this.state.assetId);
  };

  setTruck = async (url) => {
    try {
      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        let array = [];
        array.push(response.data);
        response.data = array;
        console.log(" response..", response.data);
        this.setState({
          reportDetails: response.data,
          realTimeData: response.data,
          trackDataTotal: response.data,
          reportLoader: false,
          errorLoader: false,
        });

        this.setGraph(response.data);
      }
    } catch (e) {
      this.setState({ reportLoader: false, errorLoader: true });
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  setGraph = (data) => {
    var timeX = [];
    var utcObj = {};
    var speedObj = {};

    var sensorAGraph = [];
    var sensorBGraph = [];
    var speedGraph = [];
    var timeZoneID = localStorage.getItem("timeZoneID");

    data.forEach((single) => {
      if (single.lastMessage !== null) {
        let newtime = moment
          .utc(single.lastMessage.created)
          .tz(timeZoneID)
          .format();
        var timezoneOffset = moment(newtime);
        console.log("time zone offset", timezoneOffset._tzm);
        var timeZoneSeconds = timezoneOffset._tzm;
        var myDate = new Date(single.lastMessage.created);
        var result = myDate.getTime();
        var seconds = timeZoneSeconds * 60 * 1000;

        let value = result + seconds;
        let valueUtc = utcToDate(single.lastMessage.created);
        utcObj[value] = valueUtc;
        let speedValue = single.lastMessage.gPRMC
          ? single.lastMessage.gPRMC.speed
          : null;
        let roundedSpeed = parseFloat(rounding(speedValue));

        speedObj[value] = valueUtc;
        let pointA = parseFloat(single.lastMessage.sensorAValue);
        let pointB = single.lastMessage.sensorBValue
          ? parseFloat(single.lastMessage.sensorBValue)
          : null;
        let sensorAPoint = [value, pointA];
        let sensorBPoint = [value, pointB];
        let speedPoint = [value, roundedSpeed];
        if (!timeX.includes(value)) {
          timeX.push(value);
          sensorAGraph.push(sensorAPoint);
          sensorBGraph.push(sensorBPoint);
          speedGraph.push(speedPoint);
        }
      }
    });

    this.setState({ sensorAGraph, utcObj, speedObj, sensorBGraph, speedGraph });
  };

  Comparator = (a, b) => {
    if (a[0] < b[0]) return -1;
    if (a[0] > b[0]) return 1;
    return 0;
  };

  getHour = (hour) => {
    var a = hour;
    var b = a.split(":");

    var c = parseFloat(b[0] + "." + b[1]);
    return c;
  };

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.addTransferChartDataListener();
  };

  componentWillUnmount() {
    this.releaseSignalR();
  }

  releaseSignalR() {
    if (!this.connection) {
      return;
    }
    // Release signalR handlers
    signalRHelper.unsubscribe('RealTimeMap');
    signalRHelper.unsubscribe('Powercut');
    signalRHelper.unsubscribe('Duress');

    signalRHelper.resetAssetFilter();
    signalRHelper.resetGroupFilter();

    this.connection.off("RealTimeMap");
    this.connection.off("Powercut");
    this.connection.off("Duress");
    this.connection = null;
  }

  addTransferChartDataListener = () => {
    signalRHelper.subscribe('RealTimeMap');
    signalRHelper.subscribe('Powercut');
    signalRHelper.subscribe('Duress');

    this.connection.on("RealTimeMap", (data) => {
      this.data = data;

      let currentList = [...this.state.realTimeData];
      currentList.forEach((list, index) => {
        if (list.assetId == data.assetId) {
          this.updateMap(JSON.stringify(data));

          this.setState({ realTimeData: [data] });

          //adding one more track instance
          let trackDataTotal = [...this.state.trackDataTotal];
          trackDataTotal.unshift(data);
          this.setState({ trackDataTotal });
          this.setGraph(trackDataTotal);
        }
      });
    });

    this.connection.on("Powercut", (data) => {
      console.log("entry Powercut");
      this.handlePowerCut(data);
    });

    this.connection.on("Duress", (data) => {
      console.log("entry Duress");
      this.handleDuress(data);
    });
  };

  handlePowerCut = (data) => {
    let trackDataTotal = [...this.state.trackDataTotal];
    if (trackDataTotal[0].assetId == data.assetId) {
      let powerCut = data;
      trackDataTotal[0].powerCut = powerCut;
      this.setState({ trackDataTotal });
      this.setState({ realTimeData: trackDataTotal });
    }
  };

  handleDuress = (data) => {
    if (this.state.trackDataTotal[0].assetId == data.assetId) {
      let trackDataTotal = [...this.state.trackDataTotal];
      if (trackDataTotal[0].assetId == data.assetId) {
        let duress = data;
        trackDataTotal[0].duress = duress;
        this.setState({ trackDataTotal });
      }
    }
  };

  handleAssetId = (assetId) => {
    this.setState({ assetId, assetSelect: true });
  };

  updateMap = (data) => {
    this.setState({ mapChange: data });
  };

  render() {
    return (
      <Layout>
        <Helmet>
          <title>Track</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease`
                : `contentWrapper contentWrapperSmooth`
            }
          >
            <div className="reportBody">
              <AnimateTable
                assetPlaceHolder={this.state.assetName}
                heading="Track Report"
                onAssetId={this.handleAssetId}
                onAssetName={this.handleAssetName}
                fromTrack={true}
                onDate={this.handleDate}
                onFilter={this.handleFilter}
                onCreateReport={this.handleCreateReport}
                filtering={false}
                assetSelect={this.state.assetSelect}
                dateSelect={this.state.dateSelect}
                dateplaceholder={this.state.selectedDate}
              />
              {this.state.showContent ? (
                <div className="reportBody">
                  {this.state.reportLoader ? (
                    <div className="loaderLine">
                      <br />{" "}
                      <GridLoader
                        size={7}
                        color={"#222222"}
                        loading={this.state.reportLoader}
                      />
                      <h1> &nbsp;Generating Report</h1>
                      <br />
                    </div>
                  ) : this.state.errorLoader ? (
                    <div className="loaderLine">
                      <h1>Something Went Wrong...!</h1>
                    </div>
                  ) : (
                    <React.Fragment>
                      {(this.state.reportDetails != "" && this.state.reportDetails[0].lastMessage) ? (
                        <React.Fragment>
                          <TrackSummary
                            trackDataTotal={this.state.trackDataTotal}
                          />
                          <div>
                            {" "}
                            <RealMap
                              mapChange={this.state.mapChange}
                              singleTruckZoom={this.state.singleTruckZoom}
                              realTimeData={this.state.realTimeData}
                            />
                          </div>

                          <RealTimeTemperature
                            aData={this.state.sensorAGraph}
                            bData={this.state.sensorBGraph}
                            utcObj={this.state.utcObj}
                          />

                          <RealTimeSpeed
                            sData={this.state.speedGraph}
                            speedObj={this.state.speedObj}
                          />
                          <TrackLog
                            trackDataTotal={this.state.trackDataTotal}
                          />
                        </React.Fragment>
                      ) : (
                        <AssetInforWarning
                          warningText={true}
                          warningTextMsg="No Data Available"
                        />
                      )}
                    </React.Fragment>
                  )}
                </div>
              ) : (
                <AssetInforWarning
                  warningText={true}
                  warningTextMsg="No Data Available"
                />
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
};

export default connect(mapStateToProps, mapDispatchToProps)(Track);
